var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighRebateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.408,
    height: 84.688,
    viewBox: "0 0 78.408 84.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8646",
    "data-name": "Rectangle 8646",
    width: 78.408,
    height: 84.688,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40750",
    "data-name": "Group 40750",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42383",
    "data-name": "Path 42383",
    d: "M46.142,0c.252.153.513.294.755.46a2.451,2.451,0,0,1,.283,3.815c-.736.767-1.538,1.471-2.4,2.283,1.974.475,3.763.782,5.473,1.336C64.886,12.635,74.209,22.466,77.5,37.479c4.677,21.307-9.294,42.171-30.749,46.459A39.2,39.2,0,0,1,25.693,8.676c2.014-.741,3.8.5,3.594,2.5a2.41,2.41,0,0,1-1.744,2.094A34.232,34.232,0,0,0,5.3,40.931a34.245,34.245,0,1,0,40.8-28.983l-.24.253a12.1,12.1,0,0,1,1.266.99,2.479,2.479,0,1,1-3.52,3.477q-3.026-3-6.019-6.022a2.475,2.475,0,0,1,.02-3.793q2.967-3,5.968-5.957A9.626,9.626,0,0,1,44.819,0Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42384",
    "data-name": "Path 42384",
    d: "M100.344,172.6c-1.408-.047-2.153-.434-2.564-1.3a2.4,2.4,0,0,1,.143-2.466,5.7,5.7,0,0,1,.765-.858q14.445-14.442,28.89-28.884A2.951,2.951,0,0,1,130,137.965a2.39,2.39,0,0,1,1.713,3.815,6.122,6.122,0,0,1-.652.7q-14.476,14.479-28.969,28.941a9.176,9.176,0,0,1-1.751,1.176",
    transform: "translate(-75.967 -107.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42385",
    "data-name": "Path 42385",
    d: "M104.724,139.953a8.682,8.682,0,1,1-8.642-8.729,8.74,8.74,0,0,1,8.642,8.729m-8.678-3.814a3.8,3.8,0,1,0,3.821,3.754,3.787,3.787,0,0,0-3.821-3.754",
    transform: "translate(-68.063 -102.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42386",
    "data-name": "Path 42386",
    d: "M189.012,229.2a8.678,8.678,0,1,1,8.628,8.713,8.692,8.692,0,0,1-8.628-8.713m4.852.039a3.817,3.817,0,0,0,3.828,3.833,3.826,3.826,0,1,0-3.828-3.833",
    transform: "translate(-147.259 -171.84)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRebateIcon);
export default __webpack_public_path__ + "static/media/high-rebate-icon.71ff50171a498824beaa6d52f6b7d4da.svg";
export { ForwardRef as ReactComponent };